import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { LeanTerm } from 'src/app/assabil-kernel/models/entities/control-tables/lean-term';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'term-lov',
    templateUrl: './term-lov.component.html',
    styleUrls: ['./term-lov.component.scss']
})


export class TermLovComponent extends GenericLovComponent   {

    @Input() code         : string; 
    @Input() name         : string; 

    terms                 : LeanTerm[] = [];

    columns = [
        {  prop: 'termCode', name: 'Code'},
        {  prop: 'label1', name: 'Label 1'},
        {  prop: 'label2', name: 'Label 2'},
        {  prop: 'label3', name: 'Label 3'},
        {  prop: 'label4', name: 'Label 4'},
        {  prop: 'label5', name: 'Label 5'},
    ]


//----------------------------------------------------------------------
constructor(
    public dialogRef: MatDialogRef<TermLovComponent>,
        protected controlTablesService  : ControlTablesService) {
            super();

            this.entityName = "term";
    }
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
    loadData() {
        let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
        request.strArg1 = this.code;
        request.strArg2 = this.name;

        this.controlTablesService.getList(this.entityName, request).then(result => {
            this.terms = result;
        })
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : LeanTerm){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
